import React from 'react';
import { connectCurrentRefinements } from 'react-instantsearch-dom';

interface CustomRefinementCountProps {
    targetAttribute: string,
    labelAttribute: string,
    items: [
        {
            attribute: string,
            currentRefinement: [string]
        }
    ]
}

const refinementCount = (props: CustomRefinementCountProps) => {
    const { labelAttribute, targetAttribute, items } = props;
    const current = items.find(element => element.attribute === targetAttribute);

    const currentCount = (current && current.currentRefinement.length) ?? 0;

    if (currentCount > 0) {
        return (
            <>
                {labelAttribute} <span className="button-active-refinement-count">{currentCount}</span>
            </>
        );
    }

    return (
        <>
            {labelAttribute}
        </>
    );
};

export const CustomRefinementCount = connectCurrentRefinements(refinementCount);

interface CustomAllRefinementCountProps {
    labelAttribute: string,
    items: [
        {
            attribute: string,
            currentRefinement: [string]
        }
    ]
}

const allRefinementCount = (props: CustomAllRefinementCountProps) => {
    const { labelAttribute, items } = props;

    let currentRefCount = 0;
    items.forEach(item => {
        if (item.currentRefinement) {
            currentRefCount += item.currentRefinement.length;
        }
        // currentRefCount = currentRefCount + item.currentRefinement.length;
    });
    // const current = items.find(element => element.attribute === targetAttribute);

    // const currentCount = (current && current.currentRefinement.length) ?? 0;

    if (currentRefCount > 0) {
        return (
            <>
                {labelAttribute} <span className="button-active-refinement-count">{currentRefCount}</span>
            </>
        );
    }

    return (
        <>
            {labelAttribute}
        </>
    );
};

export const CustomAllRefinementCount = connectCurrentRefinements(allRefinementCount);

export default CustomRefinementCount;
